/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import HashSvg from './icon-hash.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <HashSvg {...validProps} />;
}
SvgComponent.iconName = 'hash';

export const HashIcon = svgIconWrapper(SvgComponent);
